import { ApolloError } from '@apollo/client'

import { ProfileTranslator } from 'src/translators'
import { ProfileEntity } from 'src/types'
import { useProfileLazyQuery } from 'src/types/generated'

type First = () => void
type Second = {
  loading?: boolean
  profile?: ProfileEntity
  error?: ApolloError
}

type UseLazyGetProfileOutput = [First, Second]

export const useLazyGetProfile = (): UseLazyGetProfileOutput => {
  const [getProfile, { loading, data, error }] = useProfileLazyQuery({
    fetchPolicy: 'network-only',
  })

  return [
    getProfile,
    {
      loading,
      profile: data && data.profile ? ProfileTranslator.toEntity(data.profile) : undefined,
      error,
    },
  ]
}
